// 'use strict';

import { tick } from 'svelte';
import { readable, writable } from 'svelte/store';

    // const Server = 'https://api.coffeementor.co.kr';
    // const Server = 'https://devapi.coffeementor.co.kr';

export const
    // Server = readable('https://api.coffee.loc.kr'),
    Server = readable('https://api.coffeementor.co.kr'),
    // Server = readable('https://devapi.coffeementor.co.kr'),
    // Server = readable('http://devloc-api-coffee.kr:8089'),
    Link = readable({
        'instagram': 'https://www.instagram.com/book.mentors_official',
        'blog'     : 'https://blog.naver.com/mentors8272',
        'mentors'  : 'http://xn--l32bu1zu6f.com', // http://멘토즈.com
    }),
    /**
     * menu 정의
     */
    Menus = readable([
        {
            'id': 1,
            'cate': 'Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_espresso2.png',
            'en_name': 'Espresso',
            'ko_name': '에스프레소'
        },
        {
            'id': 2,
            'cate': 'Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Cafe-latte2.png',
            'en_name': 'Cafe Latte',
            'ko_name': '카페라떼'
        },
        {
            'id': 3,
            'cate': 'Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Vanilla-latte2.png',
            'en_name': 'Vanilla Latte',
            'ko_name': '바닐라라떼'
        },
        {
            'id': 4,
            'cate': 'Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Cafe-Mocha2.png',
            'en_name': 'Cafe Mocha',
            'ko_name': '카페모카'
        },
        {
            'id': 5,
            'cate': 'Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Mild-Americano2.png',
            'en_name': 'Americano',
            'ko_name': '아메리카노'
        },

        {
            'id': 6,
            'cate': 'Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-espresso2.png',
            'en_name': 'Iced Espresso',
            'ko_name': '아이스 에스프레소'
        },
        {
            'id': 7,
            'cate': 'Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-Mild-Americano2.png',
            'en_name': 'Iced Americano',
            'ko_name': '아이스 아메리카노'
        },
        {
            'id': 8,
            'cate': 'Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-Cafe-Mocha2.png',
            'en_name': 'Iced Cafe Mocha',
            'ko_name': '아이스 카페모카'
        },
        {
            'id': 9,
            'cate': 'Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-Cafe-latte2.png',
            'en_name': 'Iced Cafe Latte',
            'ko_name': '아이스 카페라떼'
        },
        {
            'id': 10,
            'cate': 'Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-Vanilla-latte2.png',
            'en_name': 'Iced Vanilla Latte',
            'ko_name': '아이스 바닐라라떼'
        },
        {
            'id': 11,
            'cate': 'Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Peach-Tea-Shot.png',
            'en_name': 'Iced Peach Tea Shot',
            'ko_name': '아이스 복숭아티 샷'
        },
        {
            'id': 12,
            'cate': 'Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Mango-Shot.png',
            'en_name': 'Iced Mango Shot',
            'ko_name': '아이스 망고 샷'
        },

        {
            'id': 13,
            'cate': 'Non Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Hot-Darkchoco2.png',
            'en_name': 'Darkchoco',
            'ko_name': '다크초코'
        },
        {
            'id': 14,
            'cate': 'Non Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Greentea-latte2.png',
            'en_name': 'Greentea Latte',
            'ko_name': '녹차라떼'
        },
        {
            'id': 15,
            'cate': 'Non Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Hot-Peach-Tea2.png',
            'en_name': 'Peach Tea',
            'ko_name': '복숭아티'
        },
        {
            'id': 16,
            'cate': 'Non Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Ginger-Lemontea2.png',
            'en_name': 'Ginger Lemon Tea',
            'ko_name': '진저레몬티'
        },
        {
            'id': 17,
            'cate': 'Non Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Hot-Vanilla2.png',
            'en_name': 'Hot Vanilla',
            'ko_name': '핫 바닐라'
        },
        {
            'id': 18,
            'cate': 'Non Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Earl-Grey-Milktea2.png',
            'en_name': 'Earl Grey Milk Tea',
            'ko_name': '얼그레이밀크티'
        },
        {
            'id': 19,
            'cate': 'Non Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Hot-Milk.png',
            'en_name': 'Hot Milk',
            'ko_name': '우유'
        },
        {
            'id': 20,
            'cate': 'Non Coffee',
            'type': 'Hot',
            'img': '/images/menu/ic_Grapefruitpineapple-Tea.png',
            'en_name': 'Grapefruit Pineapple Tea',
            'ko_name': '자몽파인애플티'
        },
        {
            'id': 21,
            'cate': 'Non Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-Ginger-Lemontea2.png',
            'en_name': 'Iced Ginger Lemon Tea',
            'ko_name': '아이스 진저레몬티'
        },
        {
            'id': 22,
            'cate': 'Non Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-Peach-Ice-Tea2.png',
            'en_name': 'Iced Peach Tea',
            'ko_name': '아이스 복숭아티'
        },
        {
            'id': 23,
            'cate': 'Non Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-Earl-Grey-Milktea2.png',
            'en_name': 'Iced Earl Grey Milk Tea',
            'ko_name': '아이스 얼그레이밀크티'
        },
        {
            'id': 24,
            'cate': 'Non Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Yogurt-ade.png',
            'en_name': 'Iced Yogurt Ade',
            'ko_name': '아이스 요거트에이드'
        },
        {
            'id': 25,
            'cate': 'Non Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-Vanilla2.png',
            'en_name': 'Iced Vanilla',
            'ko_name': '아이스 바닐라'
        },
        {
            'id': 26,
            'cate': 'Non Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-Grapefruitpineapple-Tea.png',
            'en_name': 'Iced Grapefruit Pineapple Tea',
            'ko_name': '아이스 자몽파인애플티'
        },
        {
            'id': 27,
            'cate': 'Non Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-Greentea-latte2.png',
            'en_name': 'Iced Greentea Latte',
            'ko_name': '아이스 녹차라떼'
        },
        {
            'id': 28,
            'cate': 'Non Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_ice-mango-juice.png',
            'en_name': 'Iced Mango Juice',
            'ko_name': '아이스 망고주스'
        },
        {
            'id': 29,
            'cate': 'Non Coffee',
            'type': 'Iced',
            'img': '/images/menu/ic_Iced-Darkchoco2.png',
            'en_name': 'Iced Darkchoco',
            'ko_name': '아이스 다크초코'
        },
    ]),
    /**
     * routes 정의
     *
     * {
     *     hash: '/brand',
     *     link: '',
     *     name: 'COFFEE MENTOR',
     *     target: '',
     *     hidden: true,
     *     child: [
     *         { hash: '/brand',  name: '브랜드 스토리' },
     *         { hash: '/coffee', name: '커피 스토리' },
     *         { hash: '/news',   name: '브랜드 소식' },
     *     ]
     * }
     *
     * 현재 해시에서 # 을 떼고 반환
     * match 가 true 라면 일치하는 이벤트가 있을때만 값을 반환한다.
     * replace에 값이 있는경우, 등록된 이벤트의 실행값이 /* 로 끝난다면 /* 이전 값과 일치하는 해시의 값을 변환한다.
     * TODO (:num)|(:any) 에 대해 대응할지 말지 고민
     * (:any) ^(hash)(.+)  | ^(?:hash)(.+), ~~~$1
     * (:num) ^(hash)(\d+)
     *
     if(
     key.slice(-2) == '/*' &&
     typeof (this.event[key]) == "function" &&
     hash.match(eval('/^(?:' + key.slice(0, -1).replace(/\//g, '\\/') + ')(.+)/g'))
     ) {
            // console.log(typeof(replace));
            // hash.replace(eval('/^(?:' + key.slice(0, -1).replace(/\//g, '\\/') + ')(.+)/g'), replace + '$1');
            // console.log(value.replace(eval('/^(?:' + hash.slice(0,-1).replace(/\//g, '\\/') + ')(.+)/g'),'/shop/detail/$1'));
            return (replace) ? hash.replace(eval('/^(?:' + key.slice(0, -1).replace(/\//g, '\\/') + ')(.+)/g'), replace + '$1') : key;
        }
     */
    Routes = writable([
        {
            href: '/home',
            name: '홈',
            hidden: true
        }, {
            href: '/brand',
            name: 'COFFEE MENTOR',
            child: [
                { href: '/brand',  name: '브랜드 스토리' },
                { href: '/coffee', name: '커피 스토리' },
                { href: '/news',   hash: '/news/*', name: '브랜드 소식' },
            ]
        }, {
            href: '/menu', name: '메뉴',
        }, {
            href: '/find', name: '매장',
        }, {
            href: '/franchise',
            name: '가맹',
            child: [
                { href: '/franchise',  name: '경쟁력' },
                { href: '/inquiry', name: '가맹 문의' },
            ]
        }, {
            href: '/ready',
            name: '준비중',
            hidden: true
        }, {
            href: '/guide',
            hash: '/guide/*',
            name: '이용약관',
            hidden: true
        }
    ]),
    /**
     * 가맹문의 - 시/도, 구/군 정의
     */
    Sido = readable({
        '서울특별시': ['종로구', '중구', '용산구', '성동구', '광진구', '동대문구', '중랑구', '성북구', '강북구', '도봉구', '노원구', '은평구', '서대문구', '마포구', '양천구', '강서구', '구로구', '금천구', '영등포구', '동작구', '관악구', '서초구', '강남구', '송파구', '강동구'],
        '부산광역시': ['중구', '서구', '동구', '영도구', '부산진구', '동래구', '남구', '북구', '해운대구', '사하구', '금정구', '강서구', '연제구', '수영구', '사상구', '기장군'],
        '대구광역시': ['중구', '동구', '서구', '남구', '북구', '수성구', '달서구', '달성군'],
        '인천광역시': ['중구', '동구', '미추홀구', '연수구', '남동구', '부평구', '계양구', '서구', '강화군', '옹진군'],
        '광주광역시': ['동구', '서구', '남구', '북구', '광산구'],
        '대전광역시': ['동구', '중구', '서구', '유성구', '대덕구'],
        '울산광역시': ['중구', '남구', '동구', '북구', '울주군'],
        '세종특별자치시': ['조치원읍', '금남면', '부강면', '소정면', '연기면', '연동면', '연서면', '장군면', '전동면', '전의면', '고운동', '다정동', '대평동', '도담동', '반곡동', '보람동', '소담동', '새롬동', '아름동', '종촌동', '한솔동', '해밀동'],
        '경기도': ['수원시', '성남시', '의정부시', '안양시', '부천시', '광명시', '평택시', '동두천시', '안산시', '고양시', '과천시', '구리시', '남양주시', '오산시', '시흥시', '군포시', '의왕시', '하남시', '용인시', '파주시', '이천시', '안성시', '김포시', '화성시', '광주시', '양주시', '포천시', '여주시', '연천군', '가평군', '양평군'],
        '강원도': ['춘천시', '원주시', '강릉시', '동해시', '태백시', '속초시', '삼척시', '홍천군', '횡성군', '영월군', '평창군', '정선군', '철원군', '화천군', '양구군', '인제군', '고성군', '양양군'],
        '충청북도': ['청주시', '충주시', '제천시', '보은군', '옥천군', '영동군', '증평군', '진천군', '괴산군', '음성군', '단양군'],
        '충청남도': ['천안시', '공주시', '보령시', '아산시', '서산시', '논산시', '계룡시', '당진시', '금산군', '부여군', '서천군', '청양군', '홍성군', '예산군', '태안군'],
        '전라북도': ['전주시', '군산시', '익산시', '정읍시', '남원시', '김제시', '완주군', '진안군', '무주군', '장수군', '임실군', '순창군', '고창군', '부안군'],
        '전라남도': ['목포시', '여수시', '순천시', '나주시', '광양시', '담양군', '곡성군', '구례군', '고흥군', '보성군', '화순군', '장흥군', '강진군', '해남군', '영암군', '무안군', '함평군', '영광군', '장성군', '완도군', '진도군', '신안군'],
        '경상북도': ['포항시', '경주시', '김천시', '안동시', '구미시', '영주시', '영천시', '상주시', '문경시', '경산시', '군위군', '의성군', '청송군', '영양군', '영덕군', '청도군', '고령군', '성주군', '칠곡군', '예천군', '봉화군', '울진군', '울릉군'],
        '경상남도': ['창원시', '진주시', '통영시', '사천시', '김해시', '밀양시', '거제시', '양산시', '의령군', '함안군', '창녕군', '고성군', '남해군', '하동군', '산청군', '함양군', '거창군', '합천군'],
        '제주특별자치도': ['제주시', '서귀포시']
    }),
    /**
     * 가맹문의 - 유입경로 정의
     */
    Funnels = readable([
        "포털사이트 검색 (네이버 등)",
        "페이스북 / 인스타그램 (SNS)",
        "블로그 / 커뮤니티",
        "유투브",
        "지인 소개",
        "언론보도",
        "기타",
    ]);


// export Stores ;
